"use client";

// useGlow — RETIRED (law_list_language v2, 2026-09-23). The cursor glow and the
// whole hover state now belong to ONE tracker, components/HoverField.tsx,
// mounted once in the root layout: it sets `data-hl` on the thing under a
// mouse or pen, writes --mx/--my on it once per frame, and clears it the
// moment the pointer leaves, the page scrolls, the window blurs or a finger
// lands, which a per-element onPointerMove could never do (it never heard
// the leave, so glows stuck).
//
// This stays as a no-op with the same shape so the existing call sites keep
// compiling; remove `onPointerMove={glow}` from them at leisure. A row only
// needs its class (see HL_SELECTOR in lib/os/hover.ts) or `data-hl-target`.

import type { PointerEvent as ReactPointerEvent } from "react";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (_e: ReactPointerEvent<HTMLElement>) => {};

export function useGlow(): (e: ReactPointerEvent<HTMLElement>) => void {
  return noop;
}
